interface TransparentErrorBoundaryProps {
  resetError: () => void;
}

/**
 * TransparentErrorBoundary - A non-blocking error boundary that doesn't impact user flow.
 * Errors are still captured and reported to Sentry, but the UI remains functional.
 * Automatically attempts to reset the error after a short delay.
 */
export default function TransparentErrorBoundary(_props: TransparentErrorBoundaryProps) {
  // Render nothing - completely transparent to the user
  // The error is still captured by Sentry's ErrorBoundary wrapper
  return null;
}
